<template>
  <section class="flex flex-col items-center">
    <img :src="require('~/assets/img/logo.svg')" alt="" aria-hidden="true" class="mx-auto">
    <article class="text-white w-3/4 sm:w-1/2 pt-12">
      <h1 class="text-lg font-bold pb-2">Wachtwoord vergeten?</h1>
      <p>Vul hieronder uw e-mailadres in en wij versturen u een link om uw wachtwoord te resetten.</p>
    </article>
    <form ref="passform" method="post" class="w-3/4 sm:w-1/2 mx-auto" @submit.prevent="submit">
      <div class="relative mb-8 mt-12">
        <label for="email" class="absolute -top-3 left-2 bg-primary block mb-1 text-white font-bold px-1">E-mailadres</label>
        <input
          id="email"
          v-model="form.email"
          type="email"
          name="email"
          class="w-full border border-white text-white bg-transparent px-3 pt-4 pb-2"
          required
        >
      </div>
      <button
        type="submit"
        class="btn btn-secondary w-full"
        :loading="loading"
      >
        Verstuur
      </button>
    </form>
    <nuxt-link :to="{name: 'inloggen'}" class="text-center text-white hover:text-primary-lighter pt-16">
      Terug naar login
    </nuxt-link>
    <nuxt-link :to="{name: 'inloggen-over'}" class="absolute right-14 bottom-12 text-white hover:text-primary transition duration-200">
      <font-awesome-icon :icon="['far', 'info-circle']" size="lg"/>
    </nuxt-link>
  </section>
</template>

<script>
export default {
  layout: 'inloggen',
  auth: false,
  middleware: 'guest',
  data() {
    return {
      loading: false,
      form: {
        email: null,
      },
    };
  },
  methods: {
    async submit() {
      this.error = {};
      this.loading = true;

      try {
        await this.$axios.post('/password/email', this.form);
        this.$toast.success('We hebben een e-mail verstuurd met instructies om een nieuw wachtwoord in te stellen.');
      } catch (err) {
        /* Todo: More extensive error resolving */
        this.$toast.error(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
